// api
import { fetchApi } from '@/api'

import router from '@/router'
// actions
const restaurantRequestsAll = (context) => {
  let url = 'restaurant/requests'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REQUESTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantRequestsForm = (context) => {
  let url = 'restaurant/requests/create'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REQUESTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantRequestsShow = (context) => {
  let url = 'restaurant/requests'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REQUESTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const restaurantRequestsCreate = (context) => {
  let url = 'restaurant/requests/create'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_REQUESTS_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantRequestsUpdate = (context) => {
  let url = 'restaurant/requests'
  let data = {}
  fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('RESTAURANT_REQUESTS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantRequestsDelete = (context, payload) => {
  let url = 'restaurant/requests'
  console.log(payload)
  fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RESTAURANT_REQUESTS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantRequestsqracces = (context, payload) => {
  let url = 'restaurant/requests/' + payload + '/registerstarVenta'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('RESTAURANT_REQUESTS_QRACCES_LIST', response)
      // router.push('reports')
    })
    .catch((error) => {
      console.error(error)
    })
}

const restaurantRequestsTurns = (context, data) => {
  return context.commit('RESTAURANT_REQUESTS_QRACCES_TURNS', data);
}

export default {
  restaurantRequestsAll,
  restaurantRequestsForm,
  restaurantRequestsShow,
  restaurantRequestsCreate,
  restaurantRequestsUpdate,
  restaurantRequestsDelete,
  restaurantRequestsqracces,
  restaurantRequestsTurns
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/requests/actions.js